export default __webpack_public_path__ + "static/home-BR-cd0194f75f8b063f3716273dda5b5a5a.svg";